// See The Fit Drawer Component
class SeeTheFitDrawer {
  constructor() {
    this.setupEventListeners();
    this.createOverlayElement();
  }

  setupEventListeners() {
    // Wait for DOM content to be fully loaded
    document.addEventListener('DOMContentLoaded', () => {
      this.initializeDrawer();
    });
  }

  initializeDrawer() {
    // Find our specific trigger button from the see_the_fit block
    const triggerButton = document.querySelector('.side-panel-links--link[data-id="3"]');
    if (!triggerButton) return;

    // Find drawer element
    const drawer = document.querySelector('.side-panel[data-side-panel-see-the-fit]');
    if (!drawer) return;

    // Move the drawer element to the end of the body to ensure it's rendered after the overlay
    document.body.appendChild(drawer);

    // Set up click handlers with stopPropagation to prevent other handlers from executing
    triggerButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation(); // Stop event from bubbling to other handlers
      e.stopImmediatePropagation(); // Stop other handlers on the same element
      this.openDrawer(drawer);
      return false; // Additional prevention of default behavior
    }, true); // Use capture phase to ensure our handler runs first

    // Set up close button
    const closeButton = drawer.querySelector('.side-panel-close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.closeDrawer(drawer);
      });
    }

    // Set up tab functionality
    this.initializeTabs();
    
    // Initialize accordions
    this.initializeAccordions(drawer);

    // Handle escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('active')) {
        this.closeDrawer(drawer);
      }
    });
  }

  createOverlayElement() {
    // Create overlay element if it doesn't exist
    if (!document.querySelector('.stf-drawer-overlay')) {
      const overlay = document.createElement('div');
      overlay.classList.add('stf-drawer-overlay');
      document.body.appendChild(overlay);

      // Add click event to close drawer when clicking overlay
      overlay.addEventListener('click', () => {
        const drawer = document.querySelector('.side-panel[data-side-panel-see-the-fit].active');
        if (drawer) {
          this.closeDrawer(drawer);
        }
      });
      
      // Garanta que a drawer está sendo renderizada DEPOIS do overlay no DOM
      const drawer = document.querySelector('.side-panel[data-side-panel-see-the-fit]');
      if (drawer) {
        document.body.appendChild(drawer);
      }
    }
  }

  openDrawer(drawer) {
    // Add active class to drawer
    drawer.classList.add('active');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('role', 'dialog');
    
    // Show overlay
    const overlay = document.querySelector('.stf-drawer-overlay');
    if (overlay) {
      overlay.classList.add('active');
    }

    // Save current scroll position
    this.scrollPosition = window.scrollY || document.documentElement.scrollTop;
    
    // Prevent page scrolling with multiple approaches for better cross-browser support
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';
    
    // Focus first focusable element in drawer
    setTimeout(() => {
      const firstFocusableElement = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }, 100);
  }

  closeDrawer(drawer) {
    // Remove active class from drawer
    drawer.classList.remove('active');
    
    // Hide overlay
    const overlay = document.querySelector('.stf-drawer-overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }

    // Restore page scrolling
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    
    // Restore scroll position
    if (this.scrollPosition !== undefined) {
      window.scrollTo(0, this.scrollPosition);
    }
  }

  initializeTabs() {
    // Find all tab buttons
    const tabButtons = document.querySelectorAll('.sp-tab-nav--button');
    
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons
        tabButtons.forEach(btn => btn.classList.remove('active'));
        
        // Add active class to clicked button
        button.classList.add('active');
        
        // Update image display
        const tabContent = button.closest('.sp-content--wrist-size');
        if (!tabContent) return;
        
        const imageWraps = tabContent.querySelectorAll('.sp-tab-content .image-wrap');
        if (!imageWraps || imageWraps.length === 0) return;
        
        // Hide all images
        imageWraps.forEach(wrap => wrap.classList.remove('active'));
        
        // Show corresponding image
        if (imageWraps[index]) {
          imageWraps[index].classList.add('active');
        }
        
        // Scroll the button into view with smooth scrolling (centered)
        const tabNavWrapper = button.closest('.sp-tab-nav--wrapper');
        if (tabNavWrapper) {
          const buttonLeft = button.offsetLeft;
          const wrapperWidth = tabNavWrapper.offsetWidth;
          const scrollPosition = buttonLeft - (wrapperWidth / 2) + (button.offsetWidth / 2);
          
          tabNavWrapper.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
        
        // Update aria-expanded attributes
        button.setAttribute('aria-expanded', 'true');
        tabButtons.forEach((btn, i) => {
          if (i !== index) {
            btn.setAttribute('aria-expanded', 'false');
          }
        });
      });
      
      // Set initial ARIA attributes
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
      button.setAttribute('aria-controls', `tab-panel-${index}`);
    });
    
    // Initialize touch slider functionality for mobile
    this.initializeMobileSlider();
  }
  
  initializeMobileSlider() {
    const tabNavWrappers = document.querySelectorAll('.sp-tab-nav--wrapper');
    
    tabNavWrappers.forEach(wrapper => {
      let isDown = false;
      let startX;
      let scrollLeft;
      
      wrapper.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX - wrapper.offsetLeft;
        scrollLeft = wrapper.scrollLeft;
      });
      
      wrapper.addEventListener('touchend', () => {
        isDown = false;
      });
      
      wrapper.addEventListener('touchcancel', () => {
        isDown = false;
      });
      
      wrapper.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.touches[0].pageX - wrapper.offsetLeft;
        const walk = (x - startX) * 1.5; // Scroll speed multiplier
        wrapper.scrollLeft = scrollLeft - walk;
      });
    });
  }
  
  initializeAccordions(drawer) {
    // Find all accordion details elements in the drawer
    const accordionDetails = drawer.querySelectorAll('details');
    
    accordionDetails.forEach(detail => {
      const summary = detail.querySelector('summary');
      const content = detail.querySelector('.collapsible__content');
      
      if (!summary || !content) return;
      
      // Garante que o accordion comece fechado ao abrir a drawer
      detail.removeAttribute('open');
      content.style.display = 'none';
      content.style.maxHeight = '0';
      content.style.opacity = '0';
      
      // Remove event listeners existentes para evitar duplicação
      const newSummary = summary.cloneNode(true);
      
      // Garantir que a seta começa na posição correta
      const svgIcon = newSummary.querySelector('svg');
      if (svgIcon) svgIcon.style.transform = 'rotate(180deg)';
      
      summary.parentNode.replaceChild(newSummary, summary);
      
      // Add click event to toggle accordion
      newSummary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle accordion state
        const isOpen = detail.hasAttribute('open');
        
        // Removido o código que fecha outros accordions automaticamente
        // Isso permite que múltiplos accordions fiquem abertos simultaneamente
        
        // Abre ou fecha este accordion
        if (isOpen) {
          // Fechando
          content.style.maxHeight = '0';
          content.style.opacity = '0';
          
          // Aguarda a animação terminar antes de fechar o elemento
          setTimeout(() => {
            detail.removeAttribute('open');
            content.style.display = 'none';
          }, 350);
        } else {
          // Abrindo
          detail.setAttribute('open', '');
          content.style.display = 'block';
          content.style.opacity = '0';
          
          // Usa duplo requestAnimationFrame para garantir renderização suave
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              content.style.maxHeight = (content.scrollHeight + 20) + 'px';
              content.style.opacity = '1';
            });
          });
        }
      });
    });
  }

  // Alpine.js integration helper
  static initializeAlpine() {
    if (typeof window.Alpine !== 'undefined') {
      document.addEventListener('alpine:init', () => {
        window.Alpine.data('seeTheFit', () => ({
          activeTab: 0,
          setActiveTab(index) {
            this.activeTab = index;
          }
        }));
      });
    }
  }
}

// Initialize the drawer component
const seeTheFitDrawer = new SeeTheFitDrawer();

// Initialize Alpine.js integration if available
SeeTheFitDrawer.initializeAlpine();
